// extracted by mini-css-extract-plugin
export default {"menuList":"style_menuList__Mffpb","questionsGrid":"style_questionsGrid__jJgF-","buttonsContainer":"style_buttonsContainer__VUYFv","cancel":"style_cancel__kEUC8"};